var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6318 2C13.4085 2 14.0589 2.58857 14.1361 3.36144C14.2562 4.56164 15.6643 5.14493 16.5979 4.38113C17.199 3.88928 18.0751 3.93297 18.6243 4.4822L19.5178 5.37567C20.067 5.9249 20.1107 6.80095 19.6188 7.4021C18.855 8.33565 19.4383 9.74383 20.6385 9.86385C21.4114 9.94114 22 10.5915 22 11.3682V12.6319C22 13.4085 21.4114 14.0589 20.6386 14.1361C19.4386 14.2561 18.8553 15.6642 19.619 16.5976C20.1108 17.1987 20.0671 18.0746 19.5179 18.6238L18.6243 19.5174C18.0751 20.0666 17.1991 20.1103 16.5979 19.6184C15.6644 18.8546 14.2562 19.4381 14.1362 20.6383C14.0589 21.4113 13.4084 22 12.6316 22H11.3682C10.5915 22 9.94114 21.4114 9.86385 20.6385C9.74383 19.4383 8.33563 18.855 7.40208 19.6189C6.80091 20.1107 5.92485 20.067 5.37561 19.5178L4.48217 18.6243C3.93293 18.0751 3.88925 17.1991 4.3811 16.5979C5.14491 15.6644 4.56164 14.2562 3.36143 14.1361C2.58856 14.0589 2 13.4085 2 12.6318V11.3683C2 10.5915 2.58861 9.94114 3.36155 9.86384C4.56187 9.74381 5.14515 8.33544 4.38128 7.40182C3.88936 6.80059 3.93303 5.92439 4.48233 5.37509L5.37565 4.48177C5.92489 3.93253 6.80103 3.8889 7.4022 4.38076C8.33565 5.1445 9.74386 4.5614 9.86387 3.36131C9.94115 2.58851 10.5914 2 11.3681 2H12.6318ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z",
    fill: "#B0AFAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/Settings.cc66988745aa577f96467218c36bee97.svg";
export { ForwardRef as ReactComponent };